// src/component/EmailModal.js
import React, { useState,useEffect } from 'react';
import Modal from 'react-modal';
import styles from './HospitalEmailModal.module.css';
import Loader from './Loader';
import { formatDate } from './utilities/formatDate';


Modal.setAppElement('#root');

function HospitalEmailModal({ isOpen, onRequestClose, test, emailLogs = [], SendEmail }) {
  const [recipientEmail, setRecipientEmail] = useState(''); // State for managing recipient email input
  const [loading, setLoading] = useState(false);
    const [emailType, setEmailType] = useState("");
   

  const handleEmailChange = (e) => {
    setRecipientEmail(e.target.value); // Handle change in email input
  };
    const handleTypeChange = (event) => {
    setEmailType(event.target.value);
  
      if (event.target.value === "doctor") {
    setRecipientEmail(test[0].SalesEntry.PrimaryPhysicianEmailId || ""); // doctorEmail should come from your data
  } else if (event.target.value=== "patient") {
    setRecipientEmail( test[0].SalesEntry.PatientEmailID|| ""); // patientEmail should come from your data
  }
  };

  const handleSubmit = async () => {
    if (!emailType || loading) return;

    setLoading(true);
    // Gather all report URLs from tests
    const reportUrls = test.map(test => test.reportUrl).filter(url => url); // Filter to include only valid URLs
    await SendEmail(recipientEmail, test, reportUrls,emailType); // Send email with report URLs
    setLoading(false);
    onRequestClose(); // Close the modal
    
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={styles["modal-content"]}
      overlayClassName="modal-overlay"
    >
      {loading && <div className="loader"></div>}
      <h2>Send Email</h2>
      <button className={styles['close-button']} onClick={onRequestClose}>×</button>
      <hr />
      <form className="modal-form">
        <section className={styles['email-history']} aria-label="Previous email records for entry">
          <h3>Previous email records for entry</h3>
          {emailLogs.length > 0 ? (
            <div className={styles['email-history-list']}>
              {emailLogs.map((log, index) => (
                <div className={styles['email-history-row']} key={`${log.salesEntryId}-${log.sentAt}-${index}`}>
                  <span className={styles['email-history-type']}>
                    {(log.emailType || 'Email').replace(/^./, (character) => character.toUpperCase())}
                  </span>
                  <span className={styles['email-history-recipient']}>{log.recipient || 'Recipient unavailable'}</span>
                  <time className={styles['email-history-time']} dateTime={log.sentAt}>
                    {formatDate(log.sentAt, { time: true })}
                  </time>
                </div>
              ))}
            </div>
          ) : (
            <p className={styles['email-history-empty']}>No previous email records.</p>
          )}
        </section>
        <div className="form-group">
          <label>Recipient Email:</label>
          <input 
            type="email" 
            value={recipientEmail} 
            onChange={handleEmailChange} 
            required 
          />
        </div>
         {/* Radio buttons for selecting recipient type */}
           {/* Radio Button Group */}
        <div className={styles["form-group"]}>
          <label className={styles["form-label"]}>Send To:</label>
          <div className={styles["radio-group"]}>
            <label className={styles["radio-label"]}>
              <input
                type="radio"
                name="recipientType"
                value="doctor"
                checked={emailType === "doctor"}
                onChange={handleTypeChange}
                required
              />
              Doctor
            </label>
            <label className={styles["radio-label"]}>
              <input
                type="radio"
                name="recipientType"
                value="patient"
                checked={emailType === "patient"}
                onChange={handleTypeChange}
                required
              />
              Patient
            </label>
          </div>
        </div>
        <div className={styles['form-group']}>
          <label>Reports</label>
          {test.length > 0 ? (
            test.map((test, index) => (
              <div key={index}>
                {test.reportUrl ? (
                  <a href={test.reportUrl} target="_blank" rel="noopener noreferrer">
                    View Report {index + 1} - {test.test}
                  </a>
                ) : (
                  <p>No report uploaded for {test.test}.</p>
                )}
              </div>
            ))
          ) : (
            <p>No reports available.</p>
          )}
        </div>
      </form>
      <button className={styles['submit-button']} disabled={loading || !emailType} onClick={handleSubmit} style={{cursor:loading || !emailType?'not-allowed':'pointer',opacity:loading || !emailType?0.6:1}}>Send</button>
    </Modal>
  );
}

export default HospitalEmailModal;
